<app-dialog
  [title]="data.title"
  [actions]="actions"
  (action)="action($event)"
  (close)="close()"
>
  <div class="update-qty">
    <div class="input-container shipmentName">
      <label for="" class="input-container_label">{{ data.label }}</label>
      <input
        type="text"
        class="input-container_input"
        [formControl]="shipmentName"
        onFocus="this.select();"
        placeholder="(Optional)"
      />
    </div>
  </div>
</app-dialog>
